import React from 'react'
import Nav from '../components/Nav/Nav';

export default function Browse() {
  return (
    <div className='overflow-x-hidden h-dvh w-screen bg-background-img bg-cover bg-repeat flex flex-col justify-center items-center'>
      <Nav />
    </div>
  )
}
